module.exports = __webpack_public_path__ + "static/media/xLargeFont.84a4a176.png";